export const USER_FIELD_TYPE = 'com.atlassian.jira.user.ApplicationUser';
